import { Navigate, Outlet } from 'react-router-dom';

// Route guard for super-admin-only pages (Admins management, Audit & Security,
// Subscription → Sub-items). Role is normalised to 'admin' in localStorage for
// both admin and super_admin, so we key on the isSuperAdmin flag set at login.
// A plain admin who deep-links here bounces to their dashboard.
export default function SuperAdminRoute() {
  const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';
  if (!isSuperAdmin) {
    return <Navigate to="/" replace data-testid="super-admin-route-redirect" />;
  }
  return <Outlet />;
}
